import { io } from "socket.io-client";
import { EVENTS } from "../utils/constants";
let socketInstance = null;
let pingInterval = null;
function startInternalPing(socket) {
  if (pingInterval) return; // already running

  pingInterval = setInterval(() => {
    if (socket.connected) {
      console.log("[socket] Internal reconnect check");
      socket.disconnect();
      setTimeout(() => {
        socket.connect();
      }, 100);
    }
  }, 84600);
}
function stopInternalPing() {
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
}
export default {
  state: {
    socket: null,
    connected: false,
    userId: null
  },
  mutations: {
    socketSetSocket(state, socket) {
      state.socket = socket;
    },
    socketSetConnected(state, status) {
      state.connected = status;
    },
    socketSetUserId(state, userId) {
      state.userId = userId;
    }
  },
  actions: {
    socketConnect({
      commit
    }) {
      // Prevent double initialization
      if (socketInstance) {
        return socketInstance;
      }
      socketInstance = io("/omny_messages", {
        transports: ["websocket"],
        path: "/omny_messages/",
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5
      });

      // --- On connect ---
      socketInstance.on("connect", () => {
        console.log("[socket] Connected", socketInstance.id);
        commit("socketSetConnected", true);
        startInternalPing(socketInstance);
      });

      // --- On disconnect ---
      socketInstance.on("disconnect", () => {
        console.warn("[socket] Disconnected");
        commit("socketSetConnected", false);
        stopInternalPing();
      });

      // --- When the server rejects connection (auth / session errors) ---
      socketInstance.on("connect_error", error => {
        console.log("[socket] connect_error:", error);
        const message = error?.message || null;
        const onLoginPage = window.location.pathname.startsWith("/login");
        if (!onLoginPage && message === "SESSION_EXPIRED") {
          stopInternalPing();
          //Verify here with a http request before showing login
          //window.$bus.trigger(EVENTS.SHOW_MUST_LOGIN);
        }
      });
      socketInstance.on("message", data => {
        console.log("[socket] Message", data);
      });
      socketInstance.on("error", data => {
        console.log("[socket] Error", data);
      });
      commit("socketSetSocket", socketInstance);
      return socketInstance;
    },
    socketDisconnect({
      state,
      commit
    }) {
      if (state.socket) {
        stopInternalPing();
        state.socket.disconnect();
        commit("socketSetConnected", false);
        commit("socketSetSocket", null);
        socketInstance = null;
      }
    },
    sendMessage({
      state,
      getters
    }, payload = {}) {
      if (state.socket && getters.socketIsConnected) {
        state.socket.emit("message", payload);
      }
    }
  },
  getters: {
    getSocket: state => state.socket,
    socketIsConnected: state => state.connected
  }
};